<template>
  <VContainer fluid class="ma-0 pa-0" style="background: #DFDFDD">
    <!-- DESKTOP -->
    <VContainer fluid class="align-start background_gray d-none d-lg-block">
      <VRow>
        <VCol cols="12" md="6" class="d-flex justify-start">
          <div class="pa-2 align-self-center ml-16">
            <VCard color="transparent" class="elevation-0">
              <VCardText class="text-h4 font-weight-medium text-primary">
                {{ $t('WITHOUT.question') }}
              </VCardText>
              <VCardText class="text-h6 font-weight-light text-primary" style="white-space: pre-line;">
                {{ $t('WITHOUT.description') }}
              </VCardText>
              <VCardText class="text-h4 text-primary mt-16" style="white-space: pre-line;">
                {{ $t('WITHOUT.points') }}
              </VCardText>
            </VCard>
          </div>
        </VCol>

        <VCol cols="12" md="6">
          <VImg
            :src="withoutReportlake"
            width="400"         
            class="d-block"      
            eager               
            contain        
            style="float: right;"
          
          />
        </VCol>
      </VRow>
    </VContainer>

    <!-- MOBILE -->
    <VContainer fluid class="background_gray d-md-none">
      <VRow>
        <VCol cols="12" md="6" class="d-flex justify-center">
          <div class="pa-2 align-self-center" style="width:100%;">
            <VCard color="transparent" class="elevation-0">
              <VCardText class="text-h4 font-weight-medium text-primary text-center">
                {{ $t('WITHOUT.question') }}
              </VCardText>
              <VCardText class="text-h6 font-weight-light text-primary text-center" style="white-space: pre-line;">
                {{ $t('WITHOUT.description') }}
              </VCardText>
              <VCardText class="text-h6 text-primary mt-16 text-center" style="white-space: pre-line;">
                {{ $t('WITHOUT.points') }}
              </VCardText>
            </VCard>
          </div>
        </VCol>

        <VCol cols="12" md="6">
          <div class="d-flex">
            <div class="pa-2 align-self-center" style="width: 100%;">
              <VImg
                :src="withoutReportlake"
                :lazy-src="withoutReportlake"
              />
            </div>
          </div>
        </VCol>
      </VRow>
    </VContainer>
  </VContainer>
</template>

<script>
import withoutReportlake from '@/assets/imgs/without_reportlake.png'

export default {
  name: 'WithoutReportLake',
  data(){
    return{
        withoutReportlake
    }
  }
}
</script>
